import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class MenusService {

    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;

        this.GetUserMenus = () => (axios.get(`${this.GetApiUrl}Menu/GetUserMenus`));
    }
}
export default ApiGet().then((apiUrl) => new MenusService(apiUrl));
